/*
 * Copyright (C) 2019 Frontier Developments PLC.
 */

import {GetterTree} from 'vuex';
import {
    ContributionListInterface,
    ContributorInterface,
    IssueInterface,
    IssueListInterface,
    IssuesStateInterface, PaginationInterface,
} from '@/store/modules/issues/types';
import {RootState} from '@/store/types';

export const getters: GetterTree<IssuesStateInterface, RootState> = {

    /**
     * Get the issues state.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {IssueInterface[]}
     */
    getIssuesState(state: IssuesStateInterface): IssuesStateInterface {
        return state;
    },

    /**
     * Get the issues.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {IssueInterface[]}
     */
    getIssues: (state: IssuesStateInterface): any => (stateName: string): IssueInterface[] | undefined => {
        if (undefined !== state[stateName]) {
            return (state[stateName] as IssueListInterface).issues;
        }
        return undefined;
    },

    /**
     * Get the currentIssue.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {IssueInterface}
     */
    getCurrentIssue(state: IssuesStateInterface): IssueInterface | undefined {
        return state.currentIssue;
    },

    /**
     * Get the currentIssue.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {IssueInterface}
     */
    currentIssueClosed(state: IssuesStateInterface): boolean {
        if (!state.currentIssue || state.currentIssue.status) {
            return false;
        }
        return 'fixed' === state.currentIssue.status;
    },

    /**
     * Get the total issues number.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {number}
     */
    getTotalIssues: (state: IssuesStateInterface): any => (stateName: string): number | undefined => {
        if (undefined !== state[stateName]) {
            return (state[stateName] as IssueListInterface).totalItems;
        }
        return undefined;
    },

    /**
     * Get the issues pagination.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {PaginationInterface | undefined}
     */
    getIssuesPagination: (state: IssuesStateInterface): any => (stateName: string): PaginationInterface | undefined => {
        if (undefined !== state[stateName]) {
            return (state[stateName] as IssueListInterface).pagination;
        }
        return undefined;
    },

    /**
     * Get the contributors.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {ContributorInterface[]}
     */
    getContributors(state: IssuesStateInterface): ContributorInterface[] | undefined {
        return (state.currentContributors as ContributionListInterface).contributors;
    },

    /**
     * Get the total contributions number.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {number}
     */
    getTotalContributions(state: IssuesStateInterface): number {
        return (state.currentContributors as ContributionListInterface).totalItems;
    },

    /**
     * Get the contributors pagination.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {PaginationInterface}
     */
    getContributorsPagination(state: IssuesStateInterface): PaginationInterface {
        return (state.currentContributors as ContributionListInterface).pagination;
    },

    /**
     * Get the search term.
     *
     * @param {IssuesStateInterface} state
     *
     * @returns {string}
     */
    getSearchTerm(state: IssuesStateInterface): string | undefined {
        return state.searchTerm;
    },
};
